import React, { Component } from "react";

import "./Bookmark.scss";
import NoteModal from "../NoteModal";
import Popup from "reactjs-popup";


function formatPrice(price) {
  if (!price) return price;
  price = price.toLocaleString("en-CA");
  return `$${price}`;
}

export default class Bookmark extends Component {
  deleteBookmark = () => {
    this.props.deleteBookmark(this.props.bookmark.id);
  };

  renderBtnNote = () => {
    return(
      <div className={ this.props.bookmark.note ? "note-link" : "note-link-not" }>
        Comment
      </div>
    );
  }

  render() {
    var defaultImageHouseUrl = this.props.bookmark.img_url
      ? "url(" + this.props.bookmark.img_url + ")"
      : "url('/static/media/house.2d23dfe4.png')";
    var cardStyle = {
      backgroundImage: defaultImageHouseUrl,
      backgroundSize: this.props.bookmark.img_url ? "cover" : "contain",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      height: "11rem",
      borderRadius: "8px",
      borderStyle: "solid",
      borderWidth: "0.2px",
      borderColor: "rgb(230, 230, 230)",
    };
    return (
      <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6 mt-4">
        <div className="row mr-2 ml-2 custom-card pl-3 pr-3 pt-2 pb-2">
          <div className="col-4 im-containt " style={cardStyle}></div>
          <div className="col-8">
            <div className="card-body">
              <h5 className="card-title">
                {this.props.bookmark.address.replace("<br/>", "\n") ||
                  this.props.bookmark.title ||
                  this.props.bookmark.description ||
                  "Title not available."}
              </h5>
              <p>
                {formatPrice(this.props.bookmark.price) ||
                  "Price not available."}
              </p>
              <div className="row">
                <div className="col-5">
                    <div className="align-middle">
                      <span className={this.props.bookmark.available ? "green-dot" : "red-dot"}></span>
                      <span className="available-text">
                        {this.props.bookmark.available ? " Available" : " Sold"}
                      </span>
                    </div>
                </div>
                <div className="col-5 ">
                  <div className="text-center align-middle">
                  <Popup
                      contentStyle={{ width: "fit-content(500px)" }}
                      lockScroll={true}
                      className="animated fadeIn faster"
                      trigger={this.renderBtnNote()}
                      modal
                      closeOnDocumentClick
                      on="click"
                  >
                      {(close) => (
                      <NoteModal
                          bookmark={this.props.bookmark}
                          close={close}
                          userInfo={this.props.userInfo}
                          reloadButton={this.renderBtnNote()}
                      />
                      )}
                  </Popup>
                  </div>
                </div>
                <div className="col-2">
                  <div className="dropdown">
                  <button
                    className="btn custom-dropdown-btn float-right"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                  <div className="dots"></div>
                  </button>
                    {!this.props.sharedBookmark ? (
                      <div
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <button
                          className="dropdown-item text-danger"
                          onClick={this.deleteBookmark}
                        >
                          Remove
                        </button>{" "}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bookmark-url">
          <a href={this.props.bookmark.url} target="_blank" rel="noreferrer">
            {this.props.bookmark.url}
          </a>
        </div>
      </div>
    );
  }
}
